import Seo from '../components/Seo';
import InquiryForm from '../components/InquiryForm';
import TrustBar from '../components/TrustBar';

export default function DistributorsPage() {
  return (
    <>
      <Seo title="Become a Distributor" description="Partner with Uclipse to distribute industrial cleaning concentrates in your region." />

      <section className="bg-gradient-to-br from-brand-700 to-brand-500 py-16 text-white">
        <div className="container-page max-w-3xl">
          <h1 className="font-display text-4xl font-bold">Distribute Uclipse in your region</h1>
          <p className="mt-4 text-lg text-brand-50/90">
            We partner with regional distributors and export buyers to grow the Uclipse brand across
            India and overseas markets.
          </p>
        </div>
      </section>

      <TrustBar variant="band" />

      <section className="container-page grid gap-10 py-14 md:grid-cols-3">
        {[
          {
            title: 'Protected territory',
            body: 'Defined regional exclusivity for committed partners with a clear go-to-market plan.',
          },
          {
            title: 'Healthy margins',
            body: 'Concentrate economics + volume slabs leave strong room for distributor and end-customer pricing.',
          },
          {
            title: 'Marketing support',
            body: 'Brand literature, datasheets, and training sessions for your sales team and end users \u2014 all under the Uclipse brand.',
          },
        ].map((b) => (
          <div key={b.title} className="card p-6">
            <h3 className="font-display text-lg font-semibold">{b.title}</h3>
            <p className="mt-2 text-sm text-slate-600">{b.body}</p>
          </div>
        ))}
      </section>

      <section className="bg-slate-50 py-16">
        <div className="container-page mx-auto max-w-2xl">
          <InquiryForm
            type="distributor"
            title="Distributor application"
            description="Share your territory and current product mix. Our partnership team will respond within 1 business day."
          />
        </div>
      </section>
    </>
  );
}
